import config from "@/config"
import http from "@/utils/request"


// export function getList(data) {
//     return http.get(`${config.API_URL}/api/app/ware-house`, data)
// }

export default {
    getPageList: {
        url: `${config.API_URL}/api/app/product/page-list`,
        name: "获取分页数据",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getVcDfStockPageList: {
        url: `${config.API_URL}/api/app/vc-df-stock/page-list`,
        name: "DF库存数据列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    vcDfStockSubmitInventory: {
        url: `${config.API_URL}/api/app/vc-df-stock/submit-inventory`,
        name: "DF库存更新",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    vcDfStockSubmitInventoryLog: {
        url: `${config.API_URL}/api/app/goods-inventory-update-log/page-list`,
        name: "DF库存更新",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    vcDfStockCreateAutoSyncInventory: {
        url: `${config.API_URL}/api/app/vc-df-stock/auto-sync-inventory`,
        name: "创建自动更新库存",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    vcDfStockGetGoodsInventoryAutoSync: {
        url: `${config.API_URL}/api/app/goods-inventory-auto-sync`,
        name: "获取是否已经设置过",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }
}
